import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

import { CarouselWithTitle } from "@faire/retailer/components/Carousel/CarouselWithTitle";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1232px;
  margin: 0 auto;
`;

export const CarouselContainer = styled.div`
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 0 56px;
  }

  ${CarouselWithTitle.AuxiliaryTitle} {
    ${responsiveMediaQueries.tabletAndAbove} {
      padding-right: 0;
    }
  }
`;
